import _ from 'lodash'

export default {
  insights: (state, getters) => ({
    dreams: _.join([
      _.size(getters.allDreamsDone),
      _.size(getters.allDreams),
    ], ' / '),
    goals: _.join([
      _.size(getters.allGoalsDone),
      _.size(getters.allGoals),
    ], ' / '),
    subgoals: _.join([
      _.size(getters.allSubgoalsDone),
      _.size(getters.allSubgoals),
    ], ' / '),
    stories: _.size(getters.stories),
  }),
  insightsByDream: (state, getters) => (dream = null) => ({
    goals: _.join([
      _.size(getters.goalsByDream(dream, true)),
      _.size(getters.goalsByDream(dream)),
    ], ' / '),
    goalsDone: _.size(getters.goalsByDream(dream, true)),
  })
}
